/**
 * VehicleDetailView - Vehicle detail modal using EntityDetailModal base
 *
 * Tabs:
 * - Overview: Vehicle info, current assignments
 * - Events: Unified timeline (maintenance, assignments, inspections, fuel, claims, documents)
 * - Coûts: TCO breakdown
 * - Documents: Document management
 * - Resources: Consumables, wear items, lifecycle scheduling
 * - Insurance: État de Parc, contracts, claims
 *
 * ALL ACCORDIONS CLOSED BY DEFAULT
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Car, Calendar, Euro, FileText, Shield, Gauge, Clock } from 'lucide-react';
import EntityDetailModal from '../../common/EntityDetailModal.jsx';
import { EventsTab, CoutsTab } from '../../common/tabs/index.js';
import VehicleOverviewTab from '../tabs/VehicleOverviewTab.jsx';
import VehicleInsuranceTab from '../tabs/VehicleInsuranceTab.jsx';
import VehicleDocumentsTab from '../tabs/VehicleDocumentsTab.jsx';
import VehicleResourcesTab from '../tabs/VehicleResourcesTab.jsx';
import VehicleUsagesTab from '../tabs/VehicleUsagesTab.jsx';

// Tab configuration for vehicles — labels résolus au rendu (changement de langue à chaud)
const VEHICLE_TABS = [
  {
    id: 'overview',
    labelKey: 'vehicles.detail.tabs.overview',
    icon: Car,
    component: VehicleOverviewTab
  },
  {
    id: 'events',
    labelKey: 'vehicles.detail.tabs.events',
    icon: Calendar,
    component: EventsTab
  },
  {
    id: 'couts',
    labelKey: 'vehicles.detail.tabs.costs',
    icon: Euro,
    component: CoutsTab
  },
  {
    id: 'documents',
    labelKey: 'vehicles.detail.tabs.documents',
    icon: FileText,
    component: VehicleDocumentsTab
  },
  {
    id: 'resources',
    labelKey: 'vehicles.detail.tabs.resources',
    icon: Gauge,
    component: VehicleResourcesTab
  },
  {
    id: 'usages',
    labelKey: 'vehicles.detail.tabs.usages',
    icon: Clock,
    component: VehicleUsagesTab
  },
  {
    id: 'insurance',
    labelKey: 'vehicles.detail.tabs.insurance',
    icon: Shield,
    component: VehicleInsuranceTab
  }
];

function VehicleDetailView({ vehicle, onClose, onMessage, onUpdate }) {
  const { t } = useTranslation();
  const tabs = VEHICLE_TABS.map(({ labelKey, ...tab }) => ({ ...tab, label: t(labelKey) }));
  if (!vehicle) return null;

  return (
    <EntityDetailModal
      isOpen={!!vehicle}
      onClose={onClose}
      onUpdate={onUpdate}
      onMessage={onMessage}
      entity={vehicle}
      entityType="vehicle"
      tabs={tabs}
      colorScheme="amber"
      headerTitle={`${vehicle.make} ${vehicle.model}`}
      headerSubtitle={t('vehicles.detail.subtitle', { plate: vehicle.license_plate, vin: vehicle.vin })}
    />
  );
}

export default VehicleDetailView;
